import React, { Fragment, useState } from "react";
import moment from "moment-hijri";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Konversi Tanggal dari Hijriah ke Masehi";
const DESCRIPTION =
  "Konversi tanggal dari Hijriah ke Masehi dengan memasukkan tanggal dalam Hijriah dan mengetahui padanannya dalam tanggal Masehi menggunakan konverter tanggal elektronik";
const KEYWORDS =
  "Hijriah, Masehi, Ummul Qura, bulan, Muharram, Safar, Ramadhan, Syawal, Dzulhijjah, Dzulqa'dah, Sya'ban, Rajab, Safar, Asyura, Rabiul Awal, Rabiul Akhir, Januari, Februari, Desember, Maret, musim semi, musim dingin, musim panas, konversi tanggal, dari hijriah ke masehi, dari masehi ke hijriah, kalender Ummul Qura, kalender hijriah, kalender Islam, kalender masehi, bulan hijriah, waktu sholat";
const OG_URL = "https://do-calculate.com/calculator/id/hijri_to_gregorian";

const HIJRI_MONTHS = [
  "Muharram",
  "Safar",
  "Rabiul Awal",
  "Rabiul Akhir",
  "Jumadil Awal",
  "Jumadil Akhir",
  "Rajab",
  "Sya'ban",
  "Ramadhan",
  "Syawal",
  "Dzulqa'dah",
  "Dzulhijjah",
];

function ConversionToGregorian() {
  const [hijriYear, setHijriYear] = useState("");
  const [hijriMonth, setHijriMonth] = useState("1");
  const [hijriDay, setHijriDay] = useState("1");
  const [gregorianDate, setGregorianDate] = useState("");
  const [showError, setShowError] = useState(false);

  const convertToGregorian = () => {
    if (!hijriYear) {
      setShowError(true);
      return;
    }

    const hijriStr = `${hijriYear}-${hijriMonth}-${hijriDay}`;
    const isValidDate = moment(hijriStr, "iYYYY-iM-iD", true).isValid();

    if (isValidDate && parseInt(hijriYear) > 1357) {
      const convertedDate = moment(hijriStr, "iYYYY-iM-iD").format("YYYY-M-D");
      setGregorianDate(convertedDate);
      setShowError(false);
    } else {
      setGregorianDate("");
      setShowError(true);
    }
  };

  return (
    <Fragment>
      <div>
        <SharedHelmet
          TITLE={TITLE}
          DESCRIPTION={DESCRIPTION}
          KEYWORDS={KEYWORDS}
          OG_URL={OG_URL}
        />
        <div className="row">
          <div className="col-12 col-md-8">
            <FirstAds />
          </div>
        </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <h1 style={{ fontSize: "17px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row p-3">
              <div>
                <p>
                  Kalkulator online ini menyediakan cara mudah untuk mengkonversi tanggal dari
                  kalender Hijriah ke Masehi. Ini memungkinkan pengguna dengan mudah menentukan arah
                  konversi dan memasukkan tanggal Hijriah yang ingin dikonversi. Setelah itu,
                  kalkulator melakukan proses secara otomatis dan menyajikan tanggal yang dikonversi
                  dalam kalender Masehi. Hasilnya ditampilkan dalam format numerik dan menyajikan hari,
                  bulan, dan tahun secara detail. Kalkulator ini memberi pengguna kesempatan untuk
                  mendapatkan dengan cepat dan akurat tanggal yang dikonversi antara kalender Hijriah
                  dan Masehi, sehingga memudahkan pengaturan waktu dan acara dalam kehidupan sehari-hari.
                </p>
                <br />
                <p>
                  Anda dapat, melalui kalkulator ini, memasukkan tanggal dalam format Hijriah, dan kalkulator akan
                  melakukan proses konversi tanggal yang dimasukkan ke padanannya dalam tanggal Masehi
                  Arab menurut kalender Ummul Qura.
                </p>
              </div>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle p-3">
              <div className="p-3 mb-3 bg-success text-white">
                Kalkulator Konversi Tanggal dari Hijriah ke Masehi
              </div>

              <label style={{ fontSize: "18px", fontWeight: "bold" }}>
                Masukkan Tanggal Hijriah
              </label>

              {/* Three Inputs in One Row */}
              <div className="row mt-3">
                <div className="col-md-4">
                  <label style={{ fontSize: "14px" }}>Hari</label>
                  <select
                    className="form-control"
                    value={hijriDay}
                    onChange={(e) => { setHijriDay(e.target.value); setGregorianDate(""); }}
                    style={{ fontSize: "16px", padding: "10px" }}
                  >
                    {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => (
                      <option key={day} value={day}>{day}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label style={{ fontSize: "14px" }}>Bulan</label>
                  <select
                    className="form-control"
                    value={hijriMonth}
                    onChange={(e) => { setHijriMonth(e.target.value); setGregorianDate(""); }}
                    style={{ fontSize: "16px", padding: "10px" }}
                  >
                    {HIJRI_MONTHS.map((month, index) => (
                      <option key={index} value={index + 1}>
                        {index + 1} - {month}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label style={{ fontSize: "14px" }}>Tahun</label>
                  <select
                    className="form-control"
                    value={hijriYear}
                    onChange={(e) => { setHijriYear(e.target.value); setGregorianDate(""); }}
                    style={{ fontSize: "16px", padding: "10px" }}
                  >
                    <option value="">Tahun</option>
                    {Array.from({ length: 1471 - 1358 }, (_, i) => 1470 - i).map((year) => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="text-center mt-3">
                <button
                  className="btn btn-success"
                  onClick={convertToGregorian}
                  style={{ fontSize: "17px", padding: "10px 40px", marginTop: "10px" }}
                >
                  Hitung
                </button>
              </div>

              {showError && (
                <p className="text-danger text-center mt-3">
                  Harap masukkan tanggal yang valid antara 1358 H dan tanggal saat ini
                </p>
              )}

              {gregorianDate && !showError && (
                <div className="mt-4">
                  <hr />
                  <div className="table-responsive">
                    <table className="table table-bordered text-center">
                      <thead className="bg-success text-white">
                        <tr>
                          <th style={{ fontSize: "20px", fontWeight: "normal" }}>Tanggal yang Dimasukkan (Hijriah)</th>
                          <th style={{ fontSize: "20px", fontWeight: "normal" }}>Bertepatan dengan Tanggal Masehi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ fontSize: "18px" }}>{`${hijriYear}-${hijriMonth}-${hijriDay}`}</td>
                          <td style={{ fontSize: "18px" }}>{gregorianDate}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
              <hr />
            </div>
          </div>

          <div className="row">
            <RelatedLinks />
            <br />
            <hr />
          </div>
        </div>

        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>

      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Konversi Tanggal Masehi ke Hijriah
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>Konversi Tanggal Masehi ke Hijriah Online</h2>
                </u>
                <br />
                <p>
                  Gunakan kalkulator online sebagai cara efektif untuk mengkonversi tanggal dari
                  kalender Masehi ke Hijriah. Misalnya, aplikasi dapat mengkonversi tanggal penerbitan paspor dari tanggal Masehi,
                  di mana hari ditentukan dua puluh, bulan ketiga, dan tahun dua ribu dua puluh, untuk menampilkan tanggal
                  yang dikonversi dalam kalender Hijriah. Dalam konteks lain, aplikasi digunakan untuk mencatat
                  tanggal kedaluwarsa kartu kredit, di mana hari kelima belas,
                  bulan kesepuluh, dan tahun dua ribu dua puluh dalam tanggal Masehi. Konversi
                  tanggal online memungkinkan pengaturan waktu dan janji dengan mudah, baik untuk tujuan perjalanan atau keuangan, dengan kemampuan untuk mengakses
                  hasil secara cepat dan akurat kapan saja dan dari mana saja di dunia.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>Langkah-langkah Konversi Tanggal</h2>
                </u>
                <br />
                <p>
                  Konverter tanggal dari Hijriah ke Masehi dan sebaliknya dengan cara yang benar Insya Allah, cukup pilih metode konversi,
                  misalnya jika Anda ingin mengkonversi tanggal Hijriah ke tanggal Masehi cukup tekan kalimat konversi
                  tanggal Hijriah, lalu pilih hari, bulan, dan tahun lalu konversi, setelah itu
                  situs akan secara otomatis menentukan tanggal yang benar sesuai kalender yang Anda pilih dengan mengubah negara atau memilih kalender Ummul Qura,
                  dan hal yang sama berlaku untuk konversi tanggal dari Masehi ke Hijriah dengan mengikuti langkah-langkah sebelumnya.
                </p>
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Aplikasi Praktis dan Contoh Konversi Tanggal dari Kalender Masehi ke Hijriah
                  </h2>
                </u>
                <br />
                <p>
                  Aplikasi efektif untuk konversi tanggal dari kalender Masehi ke Hijriah,
                  di mana contoh menampilkan tanggal lahir seseorang yang lahir di negara asing pada tanggal 15/9/2020.
                  Tanggal ini perlu dikonversi ke kalender Hijriah untuk mencatat
                  kelahiran di Kerajaan Arab Saudi, misalnya. Dengan memasukkan
                  hari 15, bulan 9, dan tahun 2020 ke dalam sistem konversi, tanggal yang dikonversi muncul
                  dalam berbagai format seperti 1442-01-28 atau 28 Muharram 1442, dan dengan demikian pekerjaan selesai dengan sukses.
                </p>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  </Fragment>
  );
}

export default ConversionToGregorian;